const BulletPoints = ({ bulletPoints, theme, iconAndTitleAlign = 'left' }) => {
  const normalizedData = {
    bulletPoints,
    theme,
    contentAlign: iconAndTitleAlign
  }

  return normalizedData
}

export default BulletPoints
